import { createHeaders } from '@wix/headers';
import whitelistedHosts from './whitelist.json';
import { extractHost, isAbsoluteUrl } from './utils';
export function requestIdOrEmptyString(response) {
    var _a;
    return ((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a['x-wix-request-id']) || '';
}
export var composeHeaders = function (_a) {
    var url = _a.url, disableWixHeaders = _a.disableWixHeaders, wixHeadersOpts = _a.wixHeadersOpts;
    var shouldAssignWixHeaders = !disableWixHeaders && isWixDomain(url);
    return shouldAssignWixHeaders ? createHeaders(wixHeadersOpts) : {};
};
export function isWixDomain(url) {
    var isRelative = !isAbsoluteUrl(url);
    if (isRelative) {
        return true;
    }
    var host = ".".concat(extractHost(url));
    var isWhitelisted = whitelistedHosts.find(function (wixHost) {
        return host.endsWith(".".concat(wixHost));
    });
    return !!isWhitelisted;
}
//# sourceMappingURL=headers.js.map